export const dischargeSummaryMetaFields = [
    {
        name: `Date`,
        field: `dateofDischarge`,
        check: `required`,
    },
    // {
    //     name: `Doctor`,
    //     field: `clinician`,
    //     check: `required`,
    // },
    {
        name: `Verified By`,
        field: `verifiedBy`,
        check: `required`,
    },
    {
        name: `Diagnosis`,
        field: `diagnosisonDischarge`,
        check: `required`,
    },
];
